import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function appidea() {
  return (
    <section className="app_amj p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../../images/case-studies/teemates/cross_plat.webp"
              alt="TekRevol"
              className="app_img"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={153}
              height={68}
            />
            <h2>1. Cross-Platform application</h2>
            <p>
              Our client was looking for a social networking app that would
              serve the users of multiple devices. Our team developed the app
              for two major digital channels: Android and iOS. Users can login
              using their Facebook or Apple credentials.
            </p>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="text-center">
            <StaticImage
              src="../../../images/case-studies/teemates/cross_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={665}
              height={636}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default appidea;
